module.exports = __webpack_public_path__ + "rules.png?398e30a9ffa99812dd8cd77c630c1679";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rules.png
// module id = 1008
// module chunks = 2